// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import EmailBuilder from './EmailBuilder';
import { renderEmail, withHeaderFooter, withFontFamily } from './emailBlocks';
import { translateItemToAllLanguages } from './services/apiService';

const API = 'https://yachtmanagementsuite.com/api';

// Thin data/orchestration container — always renders the full-screen EmailBuilder.
// No more card grid / HTML textarea editor / separate send screen.
export default function EmailCampaignPage() {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);
  const [docs, setDocs] = useState([]);
  const [docSelected, setDocSelected] = useState(null);
  const [docModeParent, setDocModeParent] = useState(false);
  const [selected, setSelected] = useState(null);
  const [editName, setEditName] = useState('Νέο πρότυπο');
  const [editSubject, setEditSubject] = useState('');
  const [builderBlocks, setBuilderBlocks] = useState([]);
  const [builderKey, setBuilderKey] = useState(0); // bump to remount Builder with fresh blocks
  const [gallery, setGallery] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [prContacts, setPrContacts] = useState([]);
  const [recipients, setRecipients] = useState([]);

  useEffect(() => { loadList(); loadGallery(); }, []);

  async function loadList() {
    try {
      const r = await fetch(`${API}/email-templates.php`);
      const data = await r.json();
      setTemplates(Array.isArray(data) ? data : []);
    } catch (e) {}
  }

  // 📋 Πρότυπα → κλικ template: φόρτωσε πλήρες record + blocks_json στον καμβά (remount)
  async function openTemplate(t) {
    try {
      const r = await fetch(`${API}/email-templates.php?id=${t.id}`);
      const full = await r.json();
      if (!full) { window.alert('Δεν βρέθηκε / Not found'); return; }
      setSelected(full);
      setEditName(full.name || '');
      setEditSubject(full.subject || '');
      let bl = [];
      try { bl = JSON.parse(full.blocks_json || '[]'); } catch { bl = []; }
      setBuilderBlocks(Array.isArray(bl) ? bl : []);
      setDocModeParent(false);
      setBuilderKey(k => k + 1);
    } catch (e) { window.alert('Σφάλμα / Error'); }
  }

  // ✚ Νέο → καθαρός καμβάς
  async function loadDocs() {
    try { const r = await fetch(`${API}/documents.php?company_id=1`); const j = await r.json(); setDocs(Array.isArray(j) ? j : []); } catch (e) { setDocs([]); }
  }
  async function openDoc(d) {
    try {
      const r = await fetch(`${API}/documents.php?company_id=1&id=${d.id}`);
      const full = await r.json();
      let blks = [];
      try { blks = JSON.parse(full.blocks_json || '[]'); } catch (e) { blks = []; }
      setDocSelected(full);
      setEditName(full.name || '');
      setBuilderBlocks(blks);
      setDocModeParent(true);
      setBuilderKey(k => k + 1);
    } catch (e) {}
  }
  function newDoc() {
    setDocSelected(null);
    setEditName('Blank / Free Build');
    setBuilderBlocks([]);
    setDocModeParent(true);
    setBuilderKey(k => k + 1);
  }
  async function deleteDocFromAdmin(d) {
    try {
      await fetch(`${API}/documents.php?company_id=1&id=${d.id}`, { method: 'DELETE' });
      await loadDocs();
      window.alert('Έγγραφο διαγράφηκε.');
    } catch (e) { window.alert('Σφάλμα διαγραφής.'); }
  }
  async function translateDoc(selId, lang, blocks) {
    try {
      const block = (blocks || builderBlocks || []).find(b => b.id === selId);
      if (!block) { window.alert('Δεν βρέθηκε το επιλεγμένο μπλοκ.'); return; }
      const src = block.props?.text ?? block.props?.label ?? '';
      if (!src) { window.alert('Το μπλοκ δεν έχει κείμενο.'); return; }
      const field = block.props?.label != null ? 'label' : 'text';
      const r = await translateItemToAllLanguages(src, src);
      const wanted = lang === 'all' ? ['el','en','it','de','ru','fr','ro','pl','he','es'] : [lang];
      let existing = {};
      try { existing = JSON.parse(docSelected?.translations_json || '{}'); } catch { existing = {}; }
      for (const lg of wanted) {
        existing[lg] = existing[lg] || {};
        existing[lg][selId] = { [field]: r[lg] };
      }
      const merged = JSON.stringify(existing);
      setDocSelected(prev => prev ? { ...prev, translations_json: merged } : { translations_json: merged });
      window.alert('Η μετάφραση ολοκληρώθηκε. Πάτησε Αποθήκευση.');
    } catch (e) {
      window.alert('Σφάλμα μετάφρασης: ' + ((e && e.message) || 'άγνωστο'));
    }
  }
  async function saveDoc(blocks, _html, name) {
    const blocks_json = JSON.stringify(blocks || []);
    const cleanName = (name === 'Blank / Free Build' ? '' : name) || (editName === 'Blank / Free Build' ? '' : editName) || 'Untitled';
    const payload = { name: cleanName, doc_type: docSelected?.doc_type || 'custom', blocks_json, translations_json: docSelected?.translations_json || null };
    try {
      if (docSelected?.id) {
        await fetch(`${API}/documents.php?company_id=1`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...payload, id: docSelected.id }) });
      } else {
        const r = await fetch(`${API}/documents.php?company_id=1`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
        const j = await r.json();
        if (j && j.id) setDocSelected({ ...payload, id: j.id });
      }
      await loadDocs();
      alert('Έγγραφο αποθηκεύτηκε.');
    } catch (e) { alert('Σφάλμα αποθήκευσης εγγράφου.'); }
  }
  function newBlank() {
    setSelected(null);
    setEditName('Νέο πρότυπο');
    setEditSubject('');
    setBuilderBlocks([]);
    setDocModeParent(false);
    setBuilderKey(k => k + 1);
  }

  // 💾 Save από τον Builder. is_builtin → πάντα νέο αντίγραφο (POST). Αλλιώς update (PUT).
  async function handleSave(blocks, html, name) {
    const blocks_json = JSON.stringify(blocks || []);
    const isUpdate = selected && selected.id && !selected.is_builtin;
    try {
      if (isUpdate) {
        const r = await fetch(`${API}/email-templates.php`, {
          method: 'PUT', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: selected.id, name, type: selected.type, lang: selected.lang, subject: editSubject, html_content: html, blocks_json }),
        });
        const res = await r.json();
        window.alert(res.ok ? '✓ Αποθηκεύτηκε / Saved' : 'Σφάλμα αποθήκευσης / Save error');
      } else {
        const copyName = (selected && selected.is_builtin) ? name + ' (copy)' : name;
        const r = await fetch(`${API}/email-templates.php`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: copyName, type: (selected && selected.type) || 'custom', lang: (selected && selected.lang) || 'en', subject: editSubject, html_content: html, is_builtin: false, blocks_json }),
        });
        const res = await r.json();
        if (res.id) {
          window.alert('✓ Αποθηκεύτηκε ως νέο / Saved as new');
          setSelected({ id: res.id, name: copyName, type: (selected && selected.type) || 'custom', lang: (selected && selected.lang) || 'en', subject: editSubject, is_builtin: false });
          setEditName(copyName);
        } else window.alert('Σφάλμα αποθήκευσης / Save error');
      }
      loadList();
    } catch (e) { window.alert('Σφάλμα / Error'); }
  }

  // 📤 Αποστολή — φόρτωσε παραλήπτες (auto από bookings + manual, ένωση by email)
  async function loadRecipients(type) {
    try {
      const [autoR, manR] = await Promise.all([
        fetch(`${API}/email-contacts.php?source=bookings&type=${type}`).then(r => r.json()),
        fetch(`${API}/email-contacts.php?type=${type}`).then(r => r.json()),
      ]);
      const auto = Array.isArray(autoR) ? autoR : [];
      const man = Array.isArray(manR) ? manR : [];
      const seen = {}; const merged = [];
      [...auto, ...man].forEach(c => {
        const k = (c.email || '').toLowerCase();
        if (k && !seen[k]) { seen[k] = 1; merged.push(c); }
      });
      setRecipients(merged);
    } catch (e) { setRecipients([]); }
  }

  const searchCharter = async (code) => {
    try {
      const r = await fetch(`${API}/bookings.php?action=search_by_code&code=${encodeURIComponent(code)}`);
      const j = await r.json();
      if (!j || !j.success || !j.booking) return null;
      const bd = j.booking.booking_data || {};
      const paid = (Array.isArray(bd.payments) ? bd.payments : []).reduce((s, p) => s + (parseFloat(p.amount) || 0), 0);
      const balance = ((parseFloat(bd.amount) || 0) - paid).toFixed(2);
      return {
        email: bd.chartererEmail || '',
        first_name: bd.chartererFirstName || '',
        last_name: bd.chartererLastName || '',
        chartererEmail: bd.chartererEmail || '',
        brokerEmail: bd.brokerEmailContact || '',
        brokerName: bd.broker || '',
        chartererFirstName: bd.chartererFirstName || '',
        chartererLastName: bd.chartererLastName || '',
        vessel: bd.vesselName || '',
        charter_code: j.booking.booking_number || code,
        start_date: bd.startDate || '',
        end_date: bd.endDate || '',
        balance
      };
    } catch (e) { return null; }
  };

  // Στέλνει το ΕΠΙΛΕΓΜΕΝΟ template (tplId) — όχι ο καμβάς. Φέρνει html_content/subject από το id.
  async function handleSend(tplId, list, htmlOverride) {
    if (!tplId) { window.alert('Διάλεξε πρότυπο / Pick a template'); return; }
    if (!list || list.length === 0) { window.alert('Δεν επιλέχθηκαν παραλήπτες / No recipients'); return; }
    if (!window.confirm(`Αποστολή σε ${list.length} παραλήπτες; / Send to ${list.length}?`)) return;
    try {
      const tr = await fetch(`${API}/email-templates.php?id=${tplId}`);
      const t = await tr.json();
      // Φρέσκο html ΠΑΝΤΑ από τα blocks (ίδιο normalization με τον builder), όχι το αποθηκευμένο html_content.
      // Fallback στο html_content αν blocks_json λείπει/invalid (να μη σπάσει η αποστολή).
      let html = (t && t.html_content) || '';
      try {
        if (t && t.blocks_json) {
          const bl = JSON.parse(t.blocks_json);
          if (Array.isArray(bl)) html = renderEmail(withFontFamily(withHeaderFooter(bl)));
        }
      } catch (e) { /* invalid blocks_json → κράτα το html_content */ }
      if (htmlOverride) html = htmlOverride;
      const r = await fetch(`${API}/email-send.php`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          subject: (t && t.subject) || '', html,
          recipients: list.map(c => ({ email: c.email, first_name: c.first_name, last_name: c.last_name, vessel: c.vessel, charter_code: c.charter_code || '', start_date: c.start_date || '', end_date: c.end_date || '', balance: c.balance || '', contact_type: c.contact_type || '', company_name: c.company_name || '' })),
          attachments: window.__emailPdfAttach || [],
        }),
      });
      const res = await r.json();
      window.alert(res.ok ? `✓ Στάλθηκαν: ${res.sent} · Απέτυχαν: ${res.failed} / Sent: ${res.sent}, Failed: ${res.failed}` : 'Σφάλμα αποστολής / Send error');
    } catch (e) { window.alert('Σφάλμα / Error'); }
  }

  async function loadGallery() {
    try {
      const r = await fetch(`${API}/email-upload-image.php`);
      const data = await r.json();
      setGallery(Array.isArray(data) ? data : []);
    } catch (e) { setGallery([]); }
  }

  async function deletePhoto(name) {
    try {
      await fetch(API + '/email-upload-image.php?name=' + encodeURIComponent(name), { method: 'DELETE' });
      loadGallery();
    } catch (e) { console.error(e); }
  }

  async function uploadImage(file) {
    if (!file) return;
    try {
      const fd = new FormData();
      fd.append('image', file);
      const r = await fetch(`${API}/email-upload-image.php`, { method: 'POST', body: fd });
      const res = await r.json();
      if (res.ok && res.url) loadGallery();
      else window.alert('Σφάλμα ανεβάσματος / Upload error: ' + (res.error || ''));
    } catch (e) { window.alert('Σφάλμα / Error'); }
  }

  // 👥 Επαφές (manual, με id για διαγραφή)
  async function loadContacts() {
    try {
      const r = await fetch(`${API}/email-contacts.php`);
      const data = await r.json();
      setContacts(Array.isArray(data) ? data : []);
    } catch (e) { setContacts([]); }
  }

  async function loadPrContacts() {
    try {
      const [cAuto, cMan, bAuto, bMan] = await Promise.all([
        fetch(`${API}/email-contacts.php?source=bookings&type=customer&exclude_skipper=1`).then(r => r.json()),
        fetch(`${API}/email-contacts.php?type=customer`).then(r => r.json()),
        fetch(`${API}/email-contacts.php?source=bookings&type=broker`).then(r => r.json()),
        fetch(`${API}/email-contacts.php?type=broker`).then(r => r.json()),
      ]);
      const dedupe = (arr) => { const seen = {}; const out = []; (Array.isArray(arr) ? arr : []).forEach(c => { const k = (c.email || '').toLowerCase(); if (k && !seen[k]) { seen[k] = 1; out.push(c); } }); return out; };
      const customers = dedupe([...(Array.isArray(cAuto) ? cAuto : []), ...(Array.isArray(cMan) ? cMan : [])]).map(c => ({ ...c, contact_type: 'customer' }));
      const brokers = dedupe([...(Array.isArray(bAuto) ? bAuto : []), ...(Array.isArray(bMan) ? bMan : [])]).filter(c => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test((c.email || '').trim())).map(c => ({ ...c, contact_type: 'broker' }));
      setPrContacts([...customers, ...brokers]);
    } catch (e) { setPrContacts([]); }
  }

  async function addContact(c) {
    const em = ((c && c.email) || '').trim();
    if (!em || !/^[^@]+@[^@]+\.[^@]+$/.test(em)) { window.alert('Μη έγκυρο email / Invalid email'); return; }
    try {
      await fetch(`${API}/email-contacts.php`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ first_name: ((c.name || '')).trim(), email: em, contact_type: c.type || 'customer' }),
      });
      loadContacts();
    } catch (e) {}
  }

  async function deleteContact(id) {
    if (!window.confirm('Διαγραφή επαφής; / Delete contact?')) return;
    try {
      await fetch(`${API}/email-contacts.php?id=${id}`, { method: 'DELETE' });
      loadContacts();
    } catch (e) {}
  }

  return (
    <EmailBuilder
      key={builderKey}
      initialBlocks={builderBlocks}
      templateName={editName}
      onBack={() => navigate('/home')}
      onSaveBlocks={handleSave}
      gallery={gallery}
      onUpload={uploadImage}
      onLoadGallery={loadGallery}
      onDeletePhoto={deletePhoto}
      templates={templates}
      onLoadTemplates={loadList}
      onPickTemplate={openTemplate}
      onNewBlank={newBlank}
      docs={docs}
      onLoadDocs={loadDocs}
      onPickDoc={openDoc}
      onNewDoc={newDoc}
      onSaveDoc={saveDoc}
      onTranslate={translateDoc}
      onDeleteDoc={deleteDocFromAdmin}
      initialDocMode={docModeParent}
      contacts={contacts}
      onLoadContacts={loadContacts}
      prContacts={prContacts}
      onLoadPrContacts={loadPrContacts}
      onAddContact={addContact}
      onDeleteContact={deleteContact}
      recipients={recipients}
      onLoadRecipients={loadRecipients}
      onSend={handleSend}
      onSearchCharter={searchCharter}
    />
  );
}
